<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick"  size="small" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right:3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectServiceDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="onFilterClick">
        <Button  size="small" type="primary">
          <!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="oldServiceDatetime">旧服务到期</DropdownItem>
          <DropdownItem name="receptDatetime">收款时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="addJt808ServCombineOrderModal=true">创建合拼订单</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcel">导出报表</Button>

      <!--<Button type="primary" size="small" style="margin-right: 3px;" @click="addJt808ServCombineOrderModal=true">添加合拼部标服务订单</Button>-->
      <!--<Button type="primary" size="small" @click="onTest">测试</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)">
          </Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <Modal v-model="setDatetimeModal" title="证明时间" @on-ok="onexportvehiclecertOk" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setVideoDatetimeModal" title="视频机证明时间" @on-ok="onOkVideo" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>

    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns"
                             :tableName="$options.name" @on-column-update="onColumnUpdate"></web-table-columns-modal>
<!--    <renewal-order-confirm-service-datetime-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderConfirmServiceDatetimeModal" :initValue="jt808ServCombineOrderConfirmServiceDatetimeId"></renewal-order-confirm-service-datetime-modal>-->
    <jt808-serv-combine-order-refuse-service-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderRefuseServiceModal" :initValue="jt808ServCombineOrderRefuseServiceId"></jt808-serv-combine-order-refuse-service-modal>
    <jt808-serv-combine-order-cancel-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderCancelModal" :initValue="jt808ServCombineOrderCancelId"></jt808-serv-combine-order-cancel-modal>
    <jt808-serv-combine-order-confirm-recept-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderConfirmReceptModal" :initValue="jt808ServCombineOrderConfirmReceptId"></jt808-serv-combine-order-confirm-recept-modal>
<!--    <renewal-order-callback-client-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderCallbackClientModal" :initValue="jt808ServCombineOrderCallbackClientId"></renewal-order-callback-client-modal>-->
<!--    <renewal-order-confirm-refuse-service-modal @on-success="onModifySuccess" v-model="jt808ServCombineOrderConfirmRefuseServiceModal" :initValue="jt808ServCombineOrderConfirmRefuseServiceId"></renewal-order-confirm-refuse-service-modal>-->
    <jt808-serv-combine-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId" @on-success="onModifySuccess"></jt808-serv-combine-order-change-business-user-modal>
    <jt808-serv-combine-order-add-to-remark-modal v-model="addToRemarkModal" :initValue="addToRemarkId" @on-success="onModifySuccess"></jt808-serv-combine-order-add-to-remark-modal>
    <add-jt808-serv-combine-order-modal v-model="addJt808ServCombineOrderModal" @on-success="onSuccess"></add-jt808-serv-combine-order-modal>
  </div>
</template>

<script>

import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import Jt808ServCombineOrderRefuseServiceModal from '@/view/om/components/jt808-serv-combine-order-refuse-service-modal'
import Jt808ServCombineOrderCancelModal from '@/view/om/components/jt808-serv-combine-order-cancel-modal'
import Jt808ServCombineOrderConfirmReceptModal from '@/view/om/components/jt808-serv-combine-order-confirm-recept-modal'
import AddJt808ServCombineOrderModal from '@/view/om/components/add-jt808-serv-combine-order-modal'
// import Jt808ServCombineOrderConfirmRefuseServiceModal from '@/view/om/components/renewal-order-confirm-refuse-service-modal'
import Jt808ServCombineOrderChangeBusinessUserModal from '@/view/om/components/jt808-serv-combine-order-change-business-user-modal'
import Jt808ServCombineOrderAddToRemarkModal from '@/view/om/components/jt808-serv-combine-order-add-to-remark-modal'

// import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'
export default {
  name: 'mybusinessjt808servcombineorders',
  components: {
    VehicleInfoDetailModal,
    // Jt808ServCombineOrderConfirmServiceDatetimeModal,
    Jt808ServCombineOrderRefuseServiceModal,
    Jt808ServCombineOrderCancelModal,
    Jt808ServCombineOrderConfirmReceptModal,
    AddJt808ServCombineOrderModal,
    // Jt808ServCombineOrderConfirmRefuseServiceModal,
    Jt808ServCombineOrderChangeBusinessUserModal,
    Jt808ServCombineOrderAddToRemarkModal
  },
  data () {
    return {
      // 设置时间
      setDatetimeId: null,
      setDatetimeModal: false,
      setVideoDatetimeModal: false,
      installDatetime: null,
      exportDatetime: null,
      adas: false,
      certificateArea: 1,

      certificateAreaOptions: [
        { label: '中山', value: 1 },
        { label: '江门', value: 2 }
      ],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      selectServiceDatetime: [],
      stateFilter: null,
      receptFilter: null,
      fileReadyFilter: null,
      reRegistrationFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      isfreeFilter: null,
      salesChannelFilter: null,
      FilterClickFilter: null,
      deviceSourceFilter: null,

      addJt808ServCombineOrderModal: false,

      // 追加备注
      addToRemarkModal: false,
      addToRemarkId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 合拼部标服务订单确认服务期
      jt808ServCombineOrderConfirmServiceDatetimeModal: false,
      jt808ServCombineOrderConfirmServiceDatetimeId: null,

      // 合拼部标服务订单拒绝服务
      jt808ServCombineOrderRefuseServiceModal: false,
      jt808ServCombineOrderRefuseServiceId: null,

      // 合拼部标服务订单作废
      jt808ServCombineOrderCancelModal: false,
      jt808ServCombineOrderCancelId: null,

      // 合拼部标服务订单确认收款
      jt808ServCombineOrderConfirmReceptModal: false,
      jt808ServCombineOrderConfirmReceptId: null,

      // 合拼部标服务订单回访确认拒绝服务
      jt808ServCombineOrderCallbackClientModal: false,
      jt808ServCombineOrderCallbackClientId: null,

      // 合拼部标服务订单停止服务
      jt808ServCombineOrderConfirmRefuseServiceModal: false,
      jt808ServCombineOrderConfirmRefuseServiceId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertRenewaled: false,

      // 订单基本信息
      jt808ServCombineOrderBaseDetailModal: false,
      jt808ServCombineOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 确认收款
      confirmReceptModal: false,
      confirmReceptId: null,

      // 合拼部标服务订单详细信息
      jt808ServCombineOrderDetailModal: false,
      jt808ServCombineOrderDetailId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      // columnsDisplay: [],
      // columnHeaders: [],
      columns: [
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 200
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'deviceSource',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          filters: [
            { label: '在网', value: 1 },
            { label: '外网转入', value: 2 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.deviceSourceFilter = []
              val.forEach(item => {
                this.deviceSourceFilter.push(genQueryParam('deviceSource', 'EQ', item))
              })
            } else {
              this.deviceSourceFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.deviceSource
            if (state === 1) {
              return h('div', '在网')
            } else if (state === 2) {
              return h('div', '外网转入')
            } else {
              return h('div', '-')
            }
          }
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let vin = ''
            if (params.row.targetPositioningDeviceInfo.vehicleInfo) {
              registrationNum = params.row.targetPositioningDeviceInfo.vehicleInfo.registrationNum === null ? '无' : params.row.targetPositioningDeviceInfo.vehicleInfo.registrationNum
              vin = params.row.targetPositioningDeviceInfo.vehicleInfo.vin === null ? '无' : params.row.targetPositioningDeviceInfo.vehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'positioningDeviceInfo.vehicleInfo.vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 240,
          render: (h, params) => {
            let display = []
            if (params.row.targetPositioningDeviceInfo.vehicleInfo) {
              if (params.row.targetPositioningDeviceInfo.vehicleInfo.clientInfo) {
                display.push(h('div', '客户信息:' + params.row.targetPositioningDeviceInfo.vehicleInfo.clientInfo.name + '(' + params.row.targetPositioningDeviceInfo.vehicleInfo.clientInfo.phoneNum + ')'))
              } else {
                display.push(h('div', '客户信息:无'))
              }
              if (params.row.targetPositioningDeviceInfo.vehicleInfo.vehicleInfoGroup) {
                display.push(h('div', '分组:' + params.row.targetPositioningDeviceInfo.vehicleInfo.vehicleInfoGroup.name))
              } else {
                display.push(h('div', '分组:无'))
              }
              return h('div', display)
            }
          }
        },
        {
          title: '部标终端主机号',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            if (params.row.jt808PositioningDeviceInfo) {
              return h('div', params.row.jt808PositioningDeviceInfo.terminalNum)
            } else {
              return h('div', '-')
            }
          }
        },
        {
          title: '部标终端类型',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            if (params.row.jt808PositioningDeviceInfo) {
              return h('div', params.row.jt808PositioningDeviceInfo.positioningDeviceModel.name)
            } else {
              return h('div', '-')
            }
          }
        },
        {
          title: '主动安全终端主机号',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.targetPositioningDeviceInfo.terminalNum)
          }
        },
        {
          title: '主动安全终端类型',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.targetPositioningDeviceInfo.positioningDeviceModel.name)
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          filters: [
            { label: '待确认服务期', value: 1 },
            { label: '待收款', value: 2 },
            { label: '已收款', value: 3 },
            { label: '待回访', value: 4 },
            { label: '待确认停止服务', value: 5 },
            { label: '停止服务', value: 6 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            if (state === 1) {
              return h('div', '待确认服务期')
            } else if (state === 2) {
              return h('div', '待收款')
            } else if (state === 3) {
              return h('div', '已收款')
            } else if (state === 4) {
              return h('div', '待回访')
            } else if (state === 5) {
              return h('div', '待确认停止服务')
            } else if (state === 6) {
              return h('div', '停止服务')
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            }
          }
        },
        {
          title: '销售渠道',
          resizable: true,
          key: 'salesChannelId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.salesChannelFilter = []
              val.forEach(item => {
                this.salesChannelFilter.push(genQueryParam('salesChannelId', 'EQ', item))
              })
            } else {
              this.salesChannelFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.salesChannel) {
              return h('div', params.row.salesChannel.name)
            }
          }
        },
        {
          title: '应收总金额',
          resizable: true,
          key: 'totalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140
        },
        {
          title: '开票类型',
          resizable: true,
          key: 'billType',
          width: 140,
          filters: [
            { label: '增值税发票', value: 1 },
            { label: '增值税专用发票', value: 2 },
            { label: '增值税普通发票', value: 3 },
            { label: '增值税电子专用发票', value: 4 },
            { label: '增值税电子普通发票', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.billTypeFilter = []
              val.forEach(item => {
                this.billTypeFilter.push(genQueryParam('billType', 'EQ', item))
              })
            } else {
              this.billTypeFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let billType = params.row.billType
            if (billType === 1) {
              return h('div', '增值税发票')
            } else if (billType === 2) {
              return h('div', '增值税专用发票')
            } else if (billType === 3) {
              return h('div', '增值税普通发票')
            } else if (billType === 4) {
              return h('div', '增值税电子专用发票')
            } else if (billType === 5) {
              return h('div', '增值税电子普通发票')
            }
          }
        },
        {
          title: '收款',
          resizable: true,
          key: 'receptDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [
            { label: '未收款', value: 0 },
            { label: '已收款', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.receptFilter = genQueryParam('receptDatetime', 'NNULL', null)
              } else {
                this.receptFilter = genQueryParam('receptDatetime', 'EQNULL', null)
              }
            } else {
              this.receptFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.receptDatetime) {
              let d = new Date(params.row.receptDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未收款')
            }
          }
        },
        {
          title: '部标上次服务到期时间',
          resizable: true,
          key: 'oldServiceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.oldServiceDatetime) {
              let d = new Date(params.row.oldServiceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '资料状态',
          resizable: true,
          key: 'fileReady',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '已准备', value: 1 },
            { label: '未准备', value: 0 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', true)
              } else {
                this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', false)
              }
            } else {
              this.fileReadyFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.fileReady) {
              return h('div', '已准备')
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未准备')
            }
          }
        },
        {
          title: '修改各平台信息',
          resizable: true,
          key: 'reRegistration',
          ellipsis: 'true',
          tooltip: 'true',
          width: 150,
          filters: [
            { label: '已修改', value: 1 },
            { label: '未修改', value: 0 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.reRegistrationFilter = genQueryParam('reRegistration', 'EQBOOL', true)
              } else {
                this.reRegistrationFilter = genQueryParam('reRegistration', 'EQBOOL', false)
              }
            } else {
              this.reRegistrationFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.reRegistration) {
              return h('div', '已修改')
            } else {
              return h('div',
                {
                  style: {
                    color: 'red'
                  }
                }, '未修改')
            }
          }
        },
        {
          title: '最后更新时间',
          resizable: true,
          key: 'updateDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '订单有效期',
          resizable: true,
          key: 'deadlineDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.deadlineDatetime) {
              let d = new Date(params.row.deadlineDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 200
        },
        {
          title: '订单历史记录',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'history',
          width: 200
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 560,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            if (!params.row.reRegistration) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>确认平台修改完成</p>',
                        onOk: () => {
                          store.dispatch('Jt808ServCombineOrderServ_ConfirmReRegistration', { params: { id: params.row.id } }).then(() => {
                            this.$Message.success('确认成功')
                            this.onModifySuccess()
                            // this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '平台修改完成')
              )
            }

            if (!params.row.fileReady && params.row.serviceDatetime) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>确认准备资料完成</p>',
                        onOk: () => {
                          store.dispatch('Jt808ServCombineOrderServ_ConfirmFileReady', { params: { id: params.row.id } }).then(() => {
                            this.$Message.success('确认成功')
                            this.onModifySuccess()
                            this.setDatetimeModal = true
                            this.setDatetimeId = params.row.targetPositioningDeviceInfo.id
                            this.exportDatetime = new Date()
                            if (params.row.targetPositioningDeviceInfo.setupDatetime) {
                              this.installDatetime = new Date(params.row.positioningDeviceInfo.setupDatetime)
                            } else {
                              this.installDatetime = new Date()
                            }
                            this.setDatetimeModal = true
                            this.adas = params.row.positioningDeviceInfo.positioningDeviceModel.adas
                            if (this.adas) {
                              if (params.row.userGroupId == 1) {
                                this.setVideoDatetimeModal = true
                              }
                            }
                            // this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '资料准备完成')
              )
            }

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.addToRemarkId = params.row.id
                    this.addToRemarkModal = true
                  }
                }
              }, '追加备注')
            )
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.targetPositioningDeviceInfo.vehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息')
            )
            if (params.row.state === 1) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderRefuseServiceId = params.row.id
                      this.jt808ServCombineOrderRefuseServiceModal = true
                    }
                  }
                }, '拒绝服务')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderCancelId = params.row.id
                      this.jt808ServCombineOrderCancelModal = true
                    }
                  }
                }, '作废')
              )
            } else if (params.row.state === 2) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderConfirmReceptId = params.row.id
                      this.jt808ServCombineOrderConfirmReceptModal = true
                    }
                  }
                }, '确认收款')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderRefuseServiceId = params.row.id
                      this.jt808ServCombineOrderRefuseServiceModal = true
                    }
                  }
                }, '拒绝服务')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderCancelId = params.row.id
                      this.jt808ServCombineOrderCancelModal = true
                    }
                  }
                }, '作废')
              )
            } else if (params.row.state === 3) {

            } else if (params.row.state === 4) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderConfirmServiceDatetimeId = params.row.id
                      this.jt808ServCombineOrderConfirmServiceDatetimeModal = true
                    }
                  }
                }, '确认服务期')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderCancelId = params.row.id
                      this.jt808ServCombineOrderCancelModal = true
                    }
                  }
                }, '作废')
              )
            } else if (params.row.state === 5) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderConfirmRefuseServiceId = params.row.id
                      this.jt808ServCombineOrderConfirmRefuseServiceModal = true
                    }
                  }
                }, '停止服务')
              )
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.jt808ServCombineOrderCancelId = params.row.id
                      this.jt808ServCombineOrderCancelModal = true
                    }
                  }
                }, '作废')
              )
            } else if (params.row.state === 6) {

            } else if (params.row.state === 0) {

            } else if (params.row.state === -1) {

            }

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.changeBusinessUserId = params.row.id
                    this.changeBusinessUserModal = true
                  }
                }
              }, '指派业务员')
            )

            return h('div', display)
          }
        }
      ]// cloumn
    }// return
  }, // data
  methods: {
    ...mapActions([
      'Jt808ServCombineOrderServ_GetPage'
    ]),
    /**
       * 导出证明
       */
    onexportvehiclecertOk () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 1
      window.location.href = '/api/im/positioningdeviceinfo/generatecertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      this.refreshPage(this.pageFilter)
    },
    onOkVideo () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 1
      let adas = this.adas
      window.location.href = '/api/im/positioningdeviceinfo/generatevideocertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + adas
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    onFilterClick (name) {
      if (name != null) {
        this.FilterClickFilter = name
        this.setPage(1)
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let qo5 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.fileReadyFilter) {
        queryParams.push(this.fileReadyFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.deviceSourceFilter) {
        qo4 = this.deviceSourceFilter
      }
      if (this.reRegistrationFilter) {
        qo5 = this.reRegistrationFilter
      }
      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
      }

      store.dispatch('Jt808ServCombineOrderServ_GetMyBusinessPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          qo5: qo5,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onTest () {
      store.dispatch('Jt808ServCombineOrderServ_OmTest', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('测试')
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    onExportExcel () {
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }

      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
      }
      let urlparams = {
        qo1: qo1,
        qo2: qo2,
        qo3: qo3,
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/om/jt808servcombineorder/getreport' + genURLParams(urlparams)
      window.location.href = url
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult) {
        return store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult) {
        return store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult) {
        return store.getters.get_Jt808ServCombineOrder_GetMyBusinessPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.columns.forEach(item => {
      //   this.columnHeaders.push(item.title)
      //   this.columnsDisplay.push(item.title)
      // })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8] }
      }).then(() => {
        let renewalers = store.getters.get_User_GetAllUsersResult
        this.renewalers = renewalers.map(item => {
          return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
          })
          // this.columns[4].filters = this.renewalers
          // this.columns[11].filters = this.marketsales
          store.dispatch('SalesChannelServ_GetAll', {
            params: null,
            urlparams: null
          }).then(() => {
            let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
            this.allSalesChannels = allSalesChannels.map(item => {
              return { label: item.name, value: item.id }
            })
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
